import React from "react";

type InputProps = {
    searchInput : string,
    updateSearchInput : (input : string) => void,
    placeholder : string,
    showResults: () => void,
    ariaLabel: string,
    searchBtnAriaLabel: string,
    setOpenSearchResults: (openSearchResults : boolean) => void,
}

export function Input ({searchInput, updateSearchInput, placeholder, showResults, ariaLabel, searchBtnAriaLabel, setOpenSearchResults}: InputProps) {

    return (
        <div className='searchFieldWrapper'>
            <input
                className='form-control searchFieldInput'
                data-nezzo-search-input=''
                value={searchInput}
                onFocus={(event) => setOpenSearchResults(true)}
                onChange={(event) => updateSearchInput(event.target.value)}
                placeholder={placeholder}
                onKeyDown={(event) => {
                    if(event.key === 'Enter') {
                        showResults();
                    }
                }}
                aria-label={ariaLabel}
            />

            <button className="button-search" onClick={showResults} aria-label={searchBtnAriaLabel} />
        </div>
    )
}